import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios } from "../common/functions";

export async function availableFormsLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const status = url.searchParams.get("status") ?? ""; // draft | published
    const type  = url.searchParams.get("type") ?? "";
    const pageParam  = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    let shouldRedirect = false;
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const fd = new FormData();
    fd.append("page", String(page));
    fd.append("limit", String(limit));
    fd.append("status", "published");
    const res = await myAxios({
        fileName: "forms/readForms.php",
        formData: fd, 
        signal: controller.signal
    });
    if (!res) throw redirect("/");
    const { items, total } = res.data;
    return {
        forms: items,
        total,
        status,
        type
    };
}